export const UPDATE_PLANS = 'Update Plans'
export const REMOVE_PLAN = 'Remove Plan'
export const UPDATE_COMPARE_MODE = 'Toggle Compare Mode'
export const UPDATE_NOTICE_TEXT = 'Update Notice Text'
export const UPDATE_COMPARING = 'Toggle Comparing Flag'
export const UPDATE_LOADING_DATA = 'Toggle Loading Indicator'